import { View } from 'react-native';

import DrawerPage from 'components/layout/drawer-page';
import { MastercardTile } from 'pages/loyalty/loyalty-partners/mastercard';
import { WalmartOffer } from 'pages/loyalty/loyalty-partners/walmart/walmart-offer';
import { t } from 'state/intl/translations';
import { useFlag } from 'state/launchdarkly';
import { LaunchDarklyFlag } from 'state/launchdarkly/flags';
import { spacing } from 'styles/constants';

export default function Partnerships() {
  const headerText = t('partnerOffers');

  const showMastercardTile = useFlag(LaunchDarklyFlag.SHOW_MASTERCARD_PARTNERSHIP);

  return (
    <DrawerPage headerText={headerText}>
      <View style={{ gap: spacing.$4 }}>
        <WalmartOffer />
        {showMastercardTile && <MastercardTile />}
      </View>
    </DrawerPage>
  );
}
